<template>
  <v-sheet height="100%" color="bg1" width="100%">
    <v-sheet height="100%" class="rounded-tl-lg overflow-hidden pa-6" style="overflow-y: auto">
      <div class="d-flex align-center mb-4" style="gap: 12px">
        <v-icon color="primary" size="28">mdi-table-arrow-right</v-icon>
        <div>
          <h3 class="mb-0">Bulk Import</h3>
          <p class="text-caption text--secondary mb-0">
            Import monitoring data from an Excel/CSV export.
          </p>
        </div>
      </div>
      <v-divider class="mb-6" />

      <v-card outlined max-width="660" class="pa-6">
        <div class="d-flex align-center mb-3" style="gap: 10px">
          <v-icon color="primary">mdi-database-import-outline</v-icon>
          <h4 class="mb-0">Corrosion Monitoring Locations (CMLs)</h4>
        </div>
        <p class="text--secondary mb-4">
          Upload a spreadsheet exported from Meridium, SAP, Maximo or another system. Each CML is
          matched to its Master Tag in this facility and <strong>upserted</strong> — re-running an
          import updates existing CMLs by their source reference instead of duplicating them.
          Measurement points (TML) and thickness readings import in the same pass; re-imports
          append only new reading dates.
        </p>
        <div class="d-flex flex-wrap align-center" style="gap: 12px">
          <v-btn
            color="primary"
            v-has.any="[permissions.Tags.Masters.Update]"
            @click="showImport = true">
            <v-icon left>mdi-upload-outline</v-icon> Start CML Import
          </v-btn>
          <v-btn outlined color="primary" @click="downloadTemplate">
            <v-icon left>mdi-download-outline</v-icon> Download template
          </v-btn>
        </div>
      </v-card>

      <cml-bulk-import-dialog v-model="showImport" />
    </v-sheet>
  </v-sheet>
</template>

<script>
  import CmlBulkImportDialog from '@/features/Tags/components/monitoring/import/CmlBulkImportDialog.vue';
  import { downloadCmlImportTemplate } from '@/features/Tags/components/monitoring/import/cmlImportTemplate';
  import { log, error as logError } from '@/utils/debugLogger';
  import permissions from '@Share/config/permissions';

  export default {
    name: 'AdminBulkImport',
    components: { CmlBulkImportDialog },
    data() {
      return {
        permissions,
        showImport: false,
      };
    },
    methods: {
      // Same generator the wizard uses — a headers-only template whose columns are
      // aligned to autoSuggest, so a filled-in file re-maps itself on the Map step.
      downloadTemplate() {
        try {
          downloadCmlImportTemplate();
          log('CML bulk import — template downloaded (admin page)');
        } catch (e) {
          logError('CML bulk import — template download failed:', e);
        }
      },
    },
  };
</script>
